export const ANALYTICS_OPT_OUT_KEY = "stoptrading.analytics.disabled";

type AnalyticsPolicyInput = {
  href: string;
  doNotTrack?: string | null;
  globalPrivacyControl?: boolean;
  automated?: boolean;
  development?: boolean;
  disabled?: boolean;
  sessionOptOut?: boolean;
  consentGranted?: boolean;
};

/** Keep production measurement free of local/preview/automated QA traffic. */
export function allowsWebAnalytics(input: AnalyticsPolicyInput): boolean {
  if (input.consentGranted !== true) return false;
  if (input.development || input.disabled || input.automated || input.sessionOptOut) return false;
  if (input.globalPrivacyControl || /^(?:1|yes)$/i.test(input.doNotTrack || "")) return false;
  try {
    const url = new URL(input.href);
    return url.protocol === "https:"
      && ["backtest.click", "www.backtest.click"].includes(url.hostname)
      && !/^\/r(?:\/|$)/.test(url.pathname)
      && url.searchParams.get("analytics") !== "off";
  } catch {
    return false;
  }
}

export function analyticsPageURL(href: string): string {
  try {
    const url = new URL(href);
    return `${url.origin}${url.pathname}`;
  } catch {
    return "";
  }
}

export function analyticsReferrerOrigin(href: string): string {
  try {
    return new URL(href).origin;
  } catch {
    return "";
  }
}
